export default __webpack_public_path__ + "static/media/325b3f1ac7630eecb5f2eab0111b57c41576153807513.91f4aefe.webp";